/* eslint-disable react/jsx-no-useless-fragment */
import { FC, ReactNode, useMemo } from 'react'
import { TListingTag, TListingType } from 'types'
import { utils } from 'utils'

const PropertyPrice: FC<{
 tag?: TListingTag
 listing?: any
 sold?: any
 extraContent?: ReactNode | string
}> = ({ tag = 'others', listing, sold, extraContent = '' }) => {
 const listingPrice = Number(listing ?? 0)
 const soldPrice = Number(sold ?? 0)

 const isStrickStyle = { textDecoration: 'line-through', color: '#777' }

 const isStrick = useMemo(
  () =>
   tag === 'sold' ||
   tag === 'leased' ||
   tag === 'expired' ||
   tag === 'suspended' ||
   tag === 'terminated' ||
   tag === 'sold-conditional' ||
   tag === 'leased-conditional',
  [tag],
 )

 return (
  <div
   className={`${isStrick ? 'has-strick ' : ''} ${
    tag !== 'sold' && tag !== 'leased' ? 'only-list-price' : ''
   }`}
  >
   <>
    {(soldPrice !== 0 && tag === 'sold') || tag === 'leased' ? (
     <>
      <span className="is-label sld--price">
       <label htmlFor="">
        {tag === 'sold' ? 'Sold Price' : 'Leased Price'}:{' '}
       </label>
       <span className="ms-1 text-primary ">
        {utils.pricefy(sold)}
        {/* {extraContent} */}
       </span>
      </span>

      <br />
      {listingPrice !== 0 && (
       <>
        <span className="is-label lstd--price">
         <label style={{ color: '#777' }} htmlFor="">
          Listed Price :{' '}
         </label>
         <span style={isStrick ? isStrickStyle : {}} className=" ms-1">
          {utils.pricefy(listingPrice)}
          {extraContent}
         </span>
        </span>
       </>
      )}
     </>
    ) : (
     listingPrice !== 0 && (
      <>
       <span className="is-label lstd--price">
        <label style={{ color: '#777' }} htmlFor="">
         Listed Price :{' '}
        </label>
        <span style={isStrick ? isStrickStyle : {}} className=" ms-1  ">
         {utils.pricefy(listingPrice)}
         {extraContent}
        </span>
       </span>
      </>
     )
    )}
   </>
  </div>
 )
}

export default PropertyPrice
